import { AgreementsDocument, AgreementsDocumentVersion } from '~/models/agreements'
import { BaseModel, convertToModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class AgreementsSignature extends BaseModel {
  static override constructorName = 'AgreementsSignature'

  id: string = ''
  email: string = ''
  phone: string = ''
  signingUrl: string = ''
  createdAt: string = ''
  document: AgreementsDocument | null = null
  version: AgreementsDocumentVersion | null = null

  constructor(data?: unknown) {
    super(data)

    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['document', 'version'])

      this.document = convertToModel(data.document, AgreementsDocument)
      this.version = convertToModel(data.version, AgreementsDocumentVersion)
    }
  }
}

registerModel(AgreementsSignature)
